import React, { forwardRef, memo, useImperativeHandle } from 'react';

import { useDisclosure } from '@chakra-ui/hooks';

import { washHub } from 'store/slices';

import { createCaseWithoutEPC } from 'api/items';
import { useMutation, useQueryClient } from 'react-query';

import { successToast } from 'utils/successToast';

import { RefType, AddCaseModalProps } from './AddManualCaseModal.props';

import AddCaseModalView from './AddManualCaseModal.view';

const Container = forwardRef<RefType, AddCaseModalProps>((_, ref) => {
  const queryClient = useQueryClient();

  const washHubId = washHub.selectors.useSelectedWashHubId();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const { mutate, isLoading } = useMutation(createCaseWithoutEPC, {
    onSuccess: () => {
      successToast('Cases created successfully');

      queryClient.invalidateQueries(`fetch-cases-${washHubId}`);

      queryClient.invalidateQueries(`fetch-cases-status-count-${washHubId}`, {
        exact: true,
      });

      onClose();
    },
  });

  useImperativeHandle(
    ref,
    () => ({
      onOpen,
    }),
    [onOpen],
  );
  const washHubSelected = washHub.selectors.useSelectedWashHub()?._id;
  const onSubmit = (values: any) => {
    values = {
      ...values,
      quantity: Number(values.quantity || '0'),
      washHub: washHubSelected,
    };
    mutate(values);
  };

  const _props = {
    isOpen,
    onClose,
    onSubmit,
    isLoading,
  };

  return <AddCaseModalView {..._props} />;
});

const AddCaseModal = memo(Container);

export default AddCaseModal;
